module.exports = __webpack_public_path__ + "media/images/clothes1-b935ee9b1f6e8d8a092fde90af4eeabb.png";